import { type ReactNode } from 'react';

export const buttonVariants = [
  'primary',
  'primary-light',
  'secondary',
  'info',
  'subtle',
  'subtle-white',
  'outline',
] as const;

export const buttonSizes = ['small', 'medium', 'large'] as const;

export type ButtonVariant = (typeof buttonVariants)[number];
export type ButtonSize = (typeof buttonSizes)[number];

export interface ButtonPropsBase {
  children?: ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
}

export interface ButtonAsButton
  extends ButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface ButtonAsLink
  extends ButtonPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type ButtonProps = ButtonAsButton | ButtonAsLink;

export const bubbleButtonVariants = ['primary', 'primary-light', 'secondary'] as const;
export type BubbleButtonVariant = (typeof bubbleButtonVariants)[number];

export interface BubbleButtonPropsBase {
  children?: ReactNode;
  variant?: BubbleButtonVariant;
  className?: string;
  ariaLabel?: string;
}

export interface BubbleButtonAsButton
  extends BubbleButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface BubbleButtonAsLink
  extends BubbleButtonPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type BubbleButtonProps = BubbleButtonAsButton | BubbleButtonAsLink;

export const roundButtonVariants = [
  'primary',
  'primary-light',
  'secondary',
  'info',
  'subtle',
] as const;
export const roundButtonSizes = ['small', 'medium'] as const;
export type RoundButtonVariant = (typeof roundButtonVariants)[number];
export type RoundButtonSize = (typeof roundButtonSizes)[number];

export interface RoundButtonPropsBase {
  children?: ReactNode;
  variant?: RoundButtonVariant;
  size?: RoundButtonSize;
  className?: string;
}

export interface RoundButtonAsButton
  extends RoundButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface RoundButtonAsLink
  extends RoundButtonPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type RoundButtonProps = RoundButtonAsButton | RoundButtonAsLink;

export const underlineButtonVariants = ['primary', 'white'] as const;
export type UnderlineButtonVariant = (typeof underlineButtonVariants)[number];

export interface UnderlineButtonPropsBase {
  children?: ReactNode;
  variant?: UnderlineButtonVariant;
  className?: string;
}

export interface UnderlineButtonAsButton
  extends UnderlineButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface UnderlineButtonAsLink
  extends UnderlineButtonPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type UnderlineButtonProps = UnderlineButtonAsButton | UnderlineButtonAsLink;

export const buttonDangerVariants = ['primary', 'secondary', 'subtle'] as const;
export const buttonDangerSizes = ['small', 'medium'] as const;
export type ButtonDangerVariant = (typeof buttonDangerVariants)[number];
export type ButtonDangerSize = (typeof buttonDangerSizes)[number];

export interface ButtonDangerPropsBase {
  children?: ReactNode;
  variant?: ButtonDangerVariant;
  size?: ButtonDangerSize;
  fullWidth?: boolean;
  className?: string;
}

export interface ButtonDangerAsButton
  extends ButtonDangerPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface ButtonDangerAsLink
  extends ButtonDangerPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type ButtonDangerProps = ButtonDangerAsButton | ButtonDangerAsLink;

export const sliderButtonVariants = ['left', 'right'] as const;
export const sliderButtonSizes = ['medium', 'large', 'xlarge'] as const;
export type SliderButtonVariant = (typeof sliderButtonVariants)[number];
export type SliderButtonSize = (typeof sliderButtonSizes)[number];

export interface SliderButtonPropsBase {
  variant?: SliderButtonVariant;
  size?: SliderButtonSize;
  className?: string;
}

export interface SliderButtonAsButton
  extends SliderButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {
  url?: never;
}

export interface SliderButtonAsLink
  extends SliderButtonPropsBase, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url: string;
}

export type SliderButtonProps = SliderButtonAsButton | SliderButtonAsLink;
